import { ChangeUsersComponentProps, ChangeUsersField } from 'app/area/favourite-administration/list/change-users/types';
import { ChangeOptionType } from 'app/area/favourite-administration/list/types';

export const hasFieldValueChanged = (prevProps: ChangeUsersComponentProps, props: ChangeUsersComponentProps) => {
  const previousForm = prevProps?.list?.changeUsers?.form ?? {};
  const currentForm = props?.list?.changeUsers?.form ?? {};

  return Object.keys(ChangeUsersField)
    .some(field => currentForm[field] !== previousForm[field]);
};

export const emptyUsers = (props: ChangeUsersComponentProps) => {
  const changeUsers = props?.list?.changeUsers?.form ?? {};

  return props.list.changeUsers.state === ChangeOptionType.Add
    && (changeUsers[ChangeUsersField.replaceExistingUsers] || []).length === 0;
};

export const isDisabled = (props: ChangeUsersComponentProps) => {
  const changeUsersFields = Object.keys(ChangeUsersField);
  const changeUsers = props?.list?.changeUsers;
  const fieldsError = changeUsers?.validation
    && changeUsersFields.map(item => changeUsers?.form[item] && changeUsers?.validation[item]).filter(f => !!f);

  return fieldsError?.length > 0 && !changeUsers?.isDirty;
};
